import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { hasAtLeastOnePrice, hasDiscount } from 'Components/utils/price/price.util';
import { PriceDiscount } from 'Components/frameworks/price/discount/PriceDiscount';
import { PriceViewRate } from 'Components/frameworks/price/view-rate/PriceViewRate';

const PriceLoader = ({ className }: { className?: string }) => (
  <span
    className={classnames(
      'block w-[2em] pr-30 text-32 after:animate-loadingDots after:content-["."]',
      className,
    )}
    data-testid="Price-loader"
  />
);

type Props = {
  bestPrice?: FormattedPrice;
  className?: string;
  color?: Colors;
  from?: Node;
  hasAsterisk?: boolean;
  hasInitialPrice?: boolean;
  hasInstalment?: boolean;
  hasTaxesAndFeesIncludedLabel?: boolean;
  hasTotalPrice?: boolean;
  initialPrice?: FormattedPrice;
  isLoading?: boolean;
  theme?: string;
  unit?: string;
  viewRates?: string;
};
export const Prices = ({
  bestPrice,
  className,
  color,
  from,
  hasAsterisk,
  hasInitialPrice,
  hasInstalment,
  hasTaxesAndFeesIncludedLabel,
  hasTotalPrice,
  initialPrice,
  isLoading,
  theme = 'default',
  unit,
  viewRates,
  ...rest
}: Props) => {
  const displayPrice = hasAtLeastOnePrice({
    initialPrice,
    bestPrice,
  });

  if (isLoading) {
    return <PriceLoader className={className} />;
  }

  if (!displayPrice && !viewRates) {
    return null;
  }

  if (!displayPrice) {
    return <PriceViewRate {...rest} className={className} label={viewRates} theme={theme} />;
  }

  return (
    <PriceDiscount
      {...rest}
      bestPrice={bestPrice}
      className={className}
      color={color}
      from={from}
      hasAsterisk={hasAsterisk}
      hasDiscount={hasDiscount({
        bestPrice,
        initialPrice,
      })}
      hasInitialPrice={hasInitialPrice}
      hasInstalment={hasInstalment}
      hasTaxesAndFeesIncludedLabel={hasTaxesAndFeesIncludedLabel}
      hasTotalPrice={hasTotalPrice}
      initialPrice={initialPrice}
      unit={unit}
      theme={theme}
    />
  );
};
